// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Чтобы оверлей списка не обрезался телом диалога */
.fias-exclusion-dialog .p-dialog-content {
  overflow: visible;
}

.fias-exclusion-picker .dropdown-results {
  z-index: 1200;
}

.fias-exclusion-picker__row {
  display: block;
}

.fias-exclusion-picker__row-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fias-exclusion-picker__row--pickable {
  cursor: pointer;
}

.fias-exclusion-picker__row--pickable:hover {
  background: #f0f0f0;
}

.fias-exclusion-picker__row--selected {
  background: #e8f4f0;
}

.fias-exclusion-picker__row--selected:hover {
  background: #d0ebe8;
}

.fias-exclusion-tags {
  padding: 0.5rem;
  border: 1px solid var(--surface-border, #dee2e6);
  border-radius: 4px;
  max-height: 140px;
  overflow-y: auto;
  min-height: 2.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/ui/detailedInformationCard/FiasAddressExclusionDialogs.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* Чтобы оверлей списка не обрезался телом диалога */\n.fias-exclusion-dialog .p-dialog-content {\n  overflow: visible;\n}\n\n.fias-exclusion-picker .dropdown-results {\n  z-index: 1200;\n}\n\n.fias-exclusion-picker__row {\n  display: block;\n}\n\n.fias-exclusion-picker__row-label {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.fias-exclusion-picker__row--pickable {\n  cursor: pointer;\n}\n\n.fias-exclusion-picker__row--pickable:hover {\n  background: #f0f0f0;\n}\n\n.fias-exclusion-picker__row--selected {\n  background: #e8f4f0;\n}\n\n.fias-exclusion-picker__row--selected:hover {\n  background: #d0ebe8;\n}\n\n.fias-exclusion-tags {\n  padding: 0.5rem;\n  border: 1px solid var(--surface-border, #dee2e6);\n  border-radius: 4px;\n  max-height: 140px;\n  overflow-y: auto;\n  min-height: 2.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
